"use client";

import React, { useState } from "react";

const EmiIcon = () => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M21.5934 13.2244C21.3144 13.0096 20.9895 12.8622 20.6442 12.7934C20.2988 12.7246 19.9422 12.7364 19.6022 12.8278L15.6797 13.7297C15.7709 13.3442 15.7738 12.943 15.6879 12.5563C15.6021 12.1695 15.4298 11.8072 15.1841 11.4965C14.9383 11.1858 14.6254 10.9347 14.2688 10.7622C13.9122 10.5896 13.5212 10.5 13.125 10.5H8.43188C8.03775 10.499 7.64733 10.5761 7.28319 10.7269C6.91904 10.8777 6.58838 11.0991 6.31031 11.3784L4.18969 13.5H1.5C1.10218 13.5 0.720644 13.658 0.43934 13.9393C0.158035 14.2206 0 14.6022 0 15L0 18.75C0 19.1478 0.158035 19.5294 0.43934 19.8107C0.720644 20.092 1.10218 20.25 1.5 20.25H11.25C11.3113 20.25 11.3724 20.2425 11.4319 20.2275L17.4319 18.7275C17.4701 18.7184 17.5075 18.7058 17.5434 18.69L21.1875 17.1394L21.2288 17.1206C21.579 16.9456 21.8789 16.6843 22.1002 16.3614C22.3215 16.0385 22.457 15.6645 22.4939 15.2747C22.5307 14.8849 22.4678 14.4922 22.3109 14.1335C22.154 13.7748 21.9084 13.4619 21.5972 13.2244H21.5934ZM1.5 15H3.75V18.75H1.5V15ZM20.5716 15.7697L17.0091 17.2866L11.1562 18.75H5.25V14.5603L7.37156 12.4397C7.51035 12.2998 7.67555 12.1889 7.85758 12.1134C8.03961 12.0379 8.23482 11.9994 8.43188 12H13.125C13.4234 12 13.7095 12.1185 13.9205 12.3295C14.1315 12.5405 14.25 12.8266 14.25 13.125C14.25 13.4234 14.1315 13.7095 13.9205 13.9205C13.7095 14.1315 13.4234 14.25 13.125 14.25H10.5C10.3011 14.25 10.1103 14.329 9.96967 14.4697C9.82902 14.6103 9.75 14.8011 9.75 15C9.75 15.1989 9.82902 15.3897 9.96967 15.5303C10.1103 15.671 10.3011 15.75 10.5 15.75H13.5C13.5565 15.7498 13.6127 15.7436 13.6678 15.7313L19.9491 14.2866L19.9781 14.2791C20.1699 14.2258 20.3745 14.2454 20.5527 14.334C20.7309 14.4226 20.87 14.5739 20.9433 14.7589C21.0167 14.9439 21.0189 15.1495 20.9498 15.3361C20.8806 15.5227 20.7449 15.6771 20.5687 15.7697H20.5716ZM15.375 9C15.5603 9.00021 15.7453 8.98516 15.9281 8.955C16.1338 9.56582 16.51 10.105 17.0124 10.5088C17.5147 10.9125 18.1222 11.164 18.763 11.2335C19.4037 11.3029 20.051 11.1875 20.6282 10.9008C21.2054 10.614 21.6884 10.168 22.0202 9.61547C22.352 9.06291 22.5186 8.42691 22.5004 7.78266C22.4821 7.1384 22.2798 6.51284 21.9173 5.97993C21.5548 5.44703 21.0473 5.02905 20.4548 4.77543C19.8623 4.52181 19.2096 4.44315 18.5737 4.54875C18.3757 3.96023 18.0192 3.43775 17.5434 3.03879C17.0676 2.63984 16.4909 2.37988 15.8769 2.28754C15.2629 2.19519 14.6353 2.27403 14.0631 2.51537C13.491 2.75672 12.9966 3.15123 12.6342 3.65547C12.2719 4.15971 12.0556 4.75414 12.0093 5.37335C11.963 5.99256 12.0885 6.61254 12.3718 7.16506C12.6552 7.71759 13.0854 8.18123 13.6153 8.50497C14.1452 8.82872 14.7541 9.00001 15.375 9ZM21 7.875C21 8.24584 20.89 8.60835 20.684 8.9167C20.478 9.22504 20.1851 9.46536 19.8425 9.60728C19.4999 9.74919 19.1229 9.78632 18.7592 9.71397C18.3955 9.64163 18.0614 9.46305 17.7992 9.20083C17.537 8.9386 17.3584 8.60451 17.286 8.2408C17.2137 7.87708 17.2508 7.50008 17.3927 7.15747C17.5346 6.81486 17.775 6.52202 18.0833 6.316C18.3916 6.10997 18.7542 6 19.125 6C19.6223 6 20.0992 6.19755 20.4508 6.54918C20.8025 6.90081 21 7.37772 21 7.875ZM15.375 3.75C15.784 3.75021 16.1818 3.88416 16.5076 4.13145C16.8334 4.37874 17.0695 4.72579 17.1797 5.11969C16.7956 5.38997 16.4721 5.73744 16.2299 6.13989C15.9878 6.54234 15.8323 6.9909 15.7734 7.45688C15.6425 7.48515 15.509 7.49961 15.375 7.5C14.8777 7.5 14.4008 7.30246 14.0492 6.95083C13.6975 6.5992 13.5 6.12228 13.5 5.625C13.5 5.12772 13.6975 4.65081 14.0492 4.29918C14.4008 3.94755 14.8777 3.75 15.375 3.75Z"
      fill="currentColor"
    />
  </svg>
);

const ProcessingIcon = () => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M2.625 12C2.42609 12 2.23532 11.921 2.09467 11.7803C1.95402 11.6397 1.875 11.4489 1.875 11.25C1.875 11.0511 1.95402 10.8603 2.09467 10.7197C2.23532 10.579 2.42609 10.5 2.625 10.5H5.25C5.44891 10.5 5.63968 10.421 5.78033 10.2803C5.92098 10.1397 6 9.94891 6 9.75C6 9.55109 5.92098 9.36032 5.78033 9.21967C5.63968 9.07902 5.44891 9 5.25 9H3.75C3.15326 9 2.58097 8.76295 2.15901 8.34099C1.73705 7.91903 1.5 7.34674 1.5 6.75C1.5 6.15326 1.73705 5.58097 2.15901 5.15901C2.58097 4.73705 3.15326 4.5 3.75 4.5C3.75 4.30109 3.82902 4.11032 3.96967 3.96967C4.11032 3.82902 4.30109 3.75 4.5 3.75C4.69891 3.75 4.88968 3.82902 5.03033 3.96967C5.17098 4.11032 5.25 4.30109 5.25 4.5H6C6.19891 4.5 6.38968 4.57902 6.53033 4.71967C6.67098 4.86032 6.75 5.05109 6.75 5.25C6.75 5.44891 6.67098 5.63968 6.53033 5.78033C6.38968 5.92098 6.19891 6 6 6H3.75C3.55109 6 3.36032 6.07902 3.21967 6.21967C3.07902 6.36032 3 6.55109 3 6.75C3 6.94891 3.07902 7.13968 3.21967 7.28033C3.36032 7.42098 3.55109 7.5 3.75 7.5H5.25C5.84674 7.5 6.41903 7.73705 6.84099 8.15901C7.26295 8.58097 7.5 9.15326 7.5 9.75C7.5 10.3467 7.26295 10.919 6.84099 11.341C6.41903 11.7629 5.84674 12 5.25 12C5.25 12.1989 5.17098 12.3897 5.03033 12.5303C4.88968 12.671 4.69891 12.75 4.5 12.75C4.30109 12.75 4.11032 12.671 3.96967 12.5303C3.82902 12.3897 3.75 12.1989 3.75 12H2.625ZM21.75 5.25V18C21.75 18.3978 21.592 18.7794 21.3107 19.0607C21.0294 19.342 20.6478 19.5 20.25 19.5H3.75C3.35218 19.5 2.97064 19.342 2.68934 19.0607C2.40804 18.7794 2.25 18.3978 2.25 18V14.25C2.25 14.0511 2.32902 13.8603 2.46967 13.7197C2.61032 13.579 2.80109 13.5 3 13.5C3.19891 13.5 3.38968 13.579 3.53033 13.7197C3.67098 13.8603 3.75 14.0511 3.75 14.25V18H15V15H7.5C7.30109 15 7.11032 14.921 6.96967 14.7803C6.82902 14.6397 6.75 14.4489 6.75 14.25C6.75 14.0511 6.82902 13.8603 6.96967 13.7197C7.11032 13.579 7.30109 13.5 7.5 13.5H15V10.5H9.75C9.55109 10.5 9.36032 10.421 9.21967 10.2803C9.07902 10.1397 9 9.94891 9 9.75C9 9.55109 9.07902 9.36032 9.21967 9.21967C9.36032 9.07902 9.55109 9 9.75 9H20.25V6H9C8.80109 6 8.61032 5.92098 8.46967 5.78033C8.32902 5.63968 8.25 5.44891 8.25 5.25C8.25 5.05109 8.32902 4.86032 8.46967 4.71967C8.61032 4.57902 8.80109 4.5 9 4.5H21C21.1989 4.5 21.3897 4.57902 21.5303 4.71967C21.671 4.86032 21.75 5.05109 21.75 5.25ZM16.5 13.5H20.25V10.5H16.5V13.5ZM20.25 18V15H16.5V18H20.25Z"
      fill="currentColor"
    />
  </svg>
);

const UpfrontIcon = () => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M22.8975 5.62487C22.7895 5.55748 22.6662 5.51868 22.5391 5.51212C22.412 5.50556 22.2853 5.53146 22.1709 5.58737C18.1462 7.55612 15.2719 6.63362 12.2334 5.6605C9.04594 4.63956 5.74125 3.58487 1.17563 5.81425C1.04806 5.87544 0.940404 5.97146 0.865091 6.09124C0.789777 6.21101 0.749878 6.34964 0.75 6.49112V17.7346C0.749982 17.8618 0.782343 17.987 0.844035 18.0983C0.905728 18.2096 0.994725 18.3033 1.10265 18.3708C1.21058 18.4382 1.33388 18.477 1.46096 18.4836C1.58804 18.4903 1.71471 18.4645 1.82906 18.4086C5.85375 16.4399 8.72812 17.3624 11.7712 18.3355C13.575 18.9121 15.4125 19.4999 17.49 19.4999C19.0922 19.4999 20.8397 19.1511 22.8253 18.1817C22.9514 18.1202 23.0577 18.0244 23.1322 17.9054C23.2066 17.7865 23.2461 17.649 23.2463 17.5086V6.26518C23.2474 6.1376 23.2159 6.01184 23.1549 5.8998C23.0939 5.78775 23.0053 5.69313 22.8975 5.62487ZM21.75 17.0314C17.9438 18.7349 15.1641 17.8461 12.2288 16.9077C10.425 16.3311 8.5875 15.7433 6.51 15.7433C5.05041 15.7504 3.60567 16.0368 2.25375 16.5871V6.96831C6.06 5.26487 8.83969 6.15362 11.775 7.09206C14.7103 8.0305 17.7319 8.99987 21.75 7.41456V17.0314ZM12 8.99987C11.4067 8.99987 10.8266 9.17582 10.3333 9.50546C9.83994 9.83511 9.45542 10.3036 9.22836 10.8518C9.0013 11.4 8.94189 12.0032 9.05764 12.5851C9.1734 13.1671 9.45912 13.7016 9.87868 14.1212C10.2982 14.5407 10.8328 14.8265 11.4147 14.9422C11.9967 15.058 12.5999 14.9986 13.1481 14.7715C13.6962 14.5444 14.1648 14.1599 14.4944 13.6666C14.8241 13.1732 15 12.5932 15 11.9999C15 11.2042 14.6839 10.4412 14.1213 9.87855C13.5587 9.31594 12.7956 8.99987 12 8.99987ZM12 13.4999C11.7033 13.4999 11.4133 13.4119 11.1666 13.2471C10.92 13.0823 10.7277 12.848 10.6142 12.5739C10.5006 12.2998 10.4709 11.9982 10.5288 11.7072C10.5867 11.4163 10.7296 11.149 10.9393 10.9392C11.1491 10.7294 11.4164 10.5866 11.7074 10.5287C11.9983 10.4708 12.2999 10.5005 12.574 10.6141C12.8481 10.7276 13.0824 10.9198 13.2472 11.1665C13.412 11.4132 13.5 11.7032 13.5 11.9999C13.5 12.3977 13.342 12.7792 13.0607 13.0605C12.7794 13.3418 12.3978 13.4999 12 13.4999ZM5.25 8.99987V13.4999C5.25 13.6988 5.17098 13.8896 5.03033 14.0302C4.88968 14.1709 4.69891 14.2499 4.5 14.2499C4.30109 14.2499 4.11032 14.1709 3.96967 14.0302C3.82902 13.8896 3.75 13.6988 3.75 13.4999V8.99987C3.75 8.80096 3.82902 8.61019 3.96967 8.46954C4.11032 8.32889 4.30109 8.24987 4.5 8.24987C4.69891 8.24987 4.88968 8.32889 5.03033 8.46954C5.17098 8.61019 5.25 8.80096 5.25 8.99987ZM18.75 14.9999V10.4999C18.75 10.301 18.829 10.1102 18.9697 9.96954C19.1103 9.82889 19.3011 9.74987 19.5 9.74987C19.6989 9.74987 19.8897 9.82889 20.0303 9.96954C20.171 10.1102 20.25 10.301 20.25 10.4999V14.9999C20.25 15.1988 20.171 15.3896 20.0303 15.5302C19.8897 15.6709 19.6989 15.7499 19.5 15.7499C19.3011 15.7499 19.1103 15.6709 18.9697 15.5302C18.829 15.3896 18.75 15.1988 18.75 14.9999Z"
      fill="currentColor"
    />
  </svg>
);

type RowVariant = "default" | "section" | "gross" | "discount" | "net";

interface FeeRow {
  label: string;
  students?: string;
  professionals?: string;
  variant?: RowVariant;
}

const feeRows: FeeRow[] = [
  {
    label: "IMA-Approved CMA Study Materials",
    students: "₹49,000",
    professionals: "₹49,000",
  },
  {
    label: "Management Accounting Training Program Fees",
    students: "₹50,000",
    professionals: "₹50,000",
  },
  { label: "IMA Fees (inclusive of GST)", variant: "section" },
  {
    label:
      "IMA Membership Fees (3 Years for Students/ 1 year for Professionals)",
    students: "$173 (₹16,305)",
    professionals: "$348 (₹32,799)",
  },
  {
    label: "IMA Entrance Fee",
    students: "$266 (₹25,071)",
    professionals: "$354 (₹33,365)",
  },
  {
    label: "IMA Exam (for both parts)",
    students: "$961 (₹90,575)",
    professionals: "$1,286 (₹1,21,206)",
  },
  {
    label: "Gross IMA Fees",
    students: "$1,400 (₹1,31,951)",
    professionals: "$1,988 (₹1,87,370)",
    variant: "gross",
  },
  {
    label: "IMA bundle discount for Miles (IMA’s Diamond Partner)",
    students: "-$534 (-₹50,329)",
    professionals: "-$573 (-₹54,006)",
    variant: "discount",
  },
  {
    label: "Net IMA Fees",
    students: "$866 (₹81,621)",
    professionals: "$1,415 (₹1,33,364)",
    variant: "net",
  },
];

const features = [
  { icon: <EmiIcon />, label: "Zero interest EMI (12 Months)" },
  { icon: <ProcessingIcon />, label: "Zero Processing Fees" },
  { icon: <UpfrontIcon />, label: "Upfront Payment ₹30,000" },
];

const rowBg: Record<RowVariant, string> = {
  default: "bg-white",
  section: "bg-[#EEF4FC]",
  gross: "bg-[#F7F8FA]",
  discount: "bg-white",
  net: "bg-[#EEF4FC]",
};

const rowText: Record<RowVariant, string> = {
  default: "text-[#161C22] font-normal",
  section: "text-[#161C22] font-bold",
  gross: "text-[#161C22] font-semibold",
  discount: "text-[#BA1A1A] font-medium",
  net: "text-[#3399FF] font-semibold",
};

const rowSize: Record<RowVariant, string> = {
  default: "text-xs md:text-sm",
  section: "text-xs md:text-sm",
  gross: "text-xs md:text-sm",
  discount: "text-xs md:text-sm",
  net: "text-base",
};

const CmaCourseFee = () => {
  const [activeTab, setActiveTab] = useState<"students" | "professionals">(
    "students",
  );

  return (
    <section className="w-full bg-[#F4F4F4] md:bg-white pt-4 md:py-[50px]">
      <div className="main_container">
        {/* On mobile the whole block sits in a white card; on desktop it is plain */}
        <div className="bg-white rounded-2xl px-4 py-5 md:bg-transparent md:rounded-none md:p-0">
          {/* Heading */}
          <h2 className="text-[24px] md:text-[32px] font-bold text-left md:text-center leading-normal">
            <span className="text-[#39F]">CMA Course</span>
            <span className="text-[#333]"> Fees Structure</span>
          </h2>
          <p className="text-[#333] text-sm md:text-sm font-normal leading-normal text-left md:text-center max-w-[700px] mx-auto mt-4 md:mt-8">
            Here&apos;s a transparent breakdown of CMA course fees and US CMA
            course fees when you enroll through Miles.
          </p>

          {/* Mobile audience toggle — replaces the two desktop columns */}
          <div className="md:hidden mt-5 flex rounded-full bg-[#F3F3F3] p-1">
            {(["students", "professionals"] as const).map((tab) => (
              <button
                key={tab}
                type="button"
                onClick={() => setActiveTab(tab)}
                aria-pressed={activeTab === tab}
                className={`flex-1 rounded-full py-2 text-[13px] font-bold capitalize transition-colors ${
                  activeTab === tab
                    ? "text-white [background:radial-gradient(1474.29%_161.47%_at_113.4%_210.95%,#B9DCFF_0%,#3A9CFF_100%)]"
                    : "bg-transparent text-[#777]"
                }`}
              >
                {tab}
              </button>
            ))}
          </div>

          {/* Fee table */}
          <div className="max-w-[736px] mx-auto md:mt-8 mt-4 overflow-hidden rounded-[10px] border border-[#C0C7D5]">
            <table className="w-full border-collapse text-left">
              <thead className="max-md:hidden">
                <tr className="bg-[#EFF6FF]">
                  <th className="w-[40%]" />
                  <th className="px-4 py-3 text-center text-sm font-semibold text-[#161C22]">
                    Students
                  </th>
                  <th className="px-4 py-3 text-center text-sm font-semibold text-[#161C22]">
                    Professionals
                  </th>
                </tr>
              </thead>
              <tbody>
                {feeRows?.map((row, index) => {
                  const variant = row.variant ?? "default";
                  // On mobile the thead is hidden, so a top border on the first
                  // row doubles up with the table container's own border.
                  const borderTop = index === 0 ? "md:border-t" : "border-t";
                  if (variant === "section") {
                    return (
                      <tr key={row.label} className={rowBg[variant]}>
                        <td
                          colSpan={3}
                          className={`px-4 py-3 ${borderTop} border-[#C0C7D5] ${rowSize[variant]} ${rowText[variant]}`}
                        >
                          {row.label}
                        </td>
                      </tr>
                    );
                  }
                  return (
                    <tr key={row.label} className={rowBg[variant]}>
                      <td
                        className={`px-4 py-3 leading-[1.5] ${borderTop} border-[#C0C7D5] ${rowSize[variant]} ${rowText[variant]}`}
                      >
                        {row.label}
                      </td>
                      <td
                        className={`px-4 py-3 max-md:text-right text-center whitespace-nowrap ${borderTop} border-[#C0C7D5] ${
                          rowSize[variant]
                        } ${
                          rowText[variant]
                        } ${activeTab === "students" ? "" : "max-md:hidden"}`}
                      >
                        {row.students}
                      </td>
                      <td
                        className={`px-4 py-3 max-md:text-right text-center whitespace-nowrap ${borderTop} border-[#C0C7D5] ${
                          rowSize[variant]
                        } ${rowText[variant]} ${
                          activeTab === "professionals" ? "" : "max-md:hidden"
                        }`}
                      >
                        {row.professionals}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>

          {/* Discount banner with centre circle */}
          <div className="relative max-w-[720px] mx-auto md:mt-12 mt-6">
            <div className="relative overflow-hidden rounded-[16px] md:rounded-[24px] text-white [background:radial-gradient(131.2%_185.75%_at_50%_50%,#1A62B3_0%,#0B2A4D_100%)]">
              {/* 50% OFF badge */}
              <div className="absolute top-0 left-0 z-20 flex items-start gap-0.5 bg-[#BA1A1A] rounded-br-2xl pl-1.5 pr-1.5 py-[4px] text-white">
                <span className="text-[16px] md:text-[26px] font-extrabold leading-none">
                  50
                </span>
                <span className="mt-0.5 flex flex-col leading-[1.05] text-[7px] md:text-[9px] font-bold">
                  <span>%</span>
                  <span>OFF</span>
                </span>
              </div>

              <div className="flex items-center justify-between px-3 md:px-8 py-3 md:py-10 min-h-[98px] md:min-h-[170px]">
                <div className="flex-1 md:flex-none md:w-[28%] text-center md:pl-4">
                  <p className="text-[13px] md:text-sm opacity-95 font-medium leading-[1.25] md:leading-normal">
                    Discounted <br className="md:hidden" />
                    CAIRA Fees
                  </p>
                  <p className="mt-1 text-[16px] md:text-[28px] font-bold">
                    ₹50,000
                  </p>
                </div>

                {/* spacer for the circle */}
                <div className="w-[112px] flex-shrink-0 md:w-[190px]" />

                <div className="flex-1 md:flex-none md:w-[28%] text-center md:pr-4">
                  <p className="text-[13px] md:text-sm opacity-95 font-medium leading-[1.25] md:leading-normal">
                    Bundle Fee <br className="md:hidden" />
                    for CMA + <br className="md:hidden" />
                    CAIRA
                  </p>
                  <p className="mt-1 text-[16px] md:text-[28px] font-bold">
                    ₹1,49,000
                  </p>
                </div>
              </div>
            </div>

            {/* Centre circle */}
            <div className="absolute top-1/2 left-1/2 z-10 -translate-x-1/2 -translate-y-1/2 flex flex-col items-center justify-center rounded-full bg-white border-4 border-[#39F] text-center w-[110px] h-[110px] md:w-[195px] md:h-[195px] shadow-[0_6px_20px_rgba(0,0,0,0.15)]">
              <span className="text-[11px] md:text-[14px] font-bold tracking-wide text-[#333]">
                PAY ONLY
              </span>
              <span className="text-[26px] md:text-[54px] font-bold leading-none text-[#3399FF]">
                ₹9,083
              </span>
              <span className="mt-0.5 text-[11px] md:text-[14px] text-[#333] font-bold">
                /Month*
              </span>
            </div>
          </div>

          {/* Features */}
          <div className="md:mt-9 mt-6 flex flex-col md:flex-row md:items-center md:justify-center gap-3 md:gap-0">
            {features?.map((feature) => (
              <div
                key={feature.label}
                className="flex items-center justify-center md:justify-start gap-2.5 text-black md:px-7 md:border-l md:first:border-l-0 border-[#dcdcdc]"
              >
                <span className="flex-shrink-0 text-[20px] md:text-[26px] text-black">
                  {feature.icon}
                </span>
                <span className="text-sm leading-snug">{feature.label}</span>
              </div>
            ))}
          </div>

          {/* Disclaimer */}
          <p className="text-[#333] text-xs md:text-sm font-normal leading-normal text-left md:text-center max-w-[760px] mx-auto md:mt-8 mt-5 tracking-[-0.42px]">
            As an IMA Diamond Partner, Miles passes on exclusive fee savings
            across membership, entrance, and exam costs so your CMA course fees
            go further.{" "}
            <i>
              Fees are per current IMA and Miles pricing and are revised
              periodically; confirm the latest CMA course fees with a Miles
              counsellor.
            </i>
          </p>

          {/* CTA */}
          <div className="flex justify-center md:mt-8 mt-5">
            <a
              href="https://www.mileseducation.com/cma/cma-fees"
              className="inline-flex items-center justify-center gap-2 h-[38px] px-5 py-3 rounded-tl-[20px] rounded-tr-[20px] rounded-br-[20px] rounded-bl-none bg-[#39F] text-white text-[13px] md:text-base font-bold leading-none whitespace-nowrap max-md:w-full"
            >
              See the full CMA fees breakdown <span aria-hidden="true">→</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CmaCourseFee;
